'use client'

import { useContext } from 'react'
import { IconChevronDown, IconTruckDelivery } from '@tabler/icons-react'
import clsx from 'clsx'

import {
  CartDeliverySlotSelectionView,
  useDisplayCart,
  useFirstAvailableDeliverySlots
} from 'modules/cart'
import { RibbonContext } from 'modules/content'
import { formatDeliveryExtendedData } from 'modules/delivery'
import { NavigationOpenables } from 'shared/types/navigation'
import { Drawer, DrawerTitle } from 'shared/ui/Drawer'
import type { DrawerProps } from 'shared/ui/Drawer/Drawer'
import { isNotNilOrEmpty } from 'shared/utils/ramda'

import styles from './DeliveryReservationModal.module.scss'

const DeliveryReservationModal = ({
  open,
  setOpen
}: {
  open: boolean
  setOpen: (name: NavigationOpenables, value: boolean) => void
}) => {
  const cart = useDisplayCart()
  const { firstAvailableTmsDeliverySlot } = useFirstAvailableDeliverySlots()
  const { ribbon } = useContext(RibbonContext)

  return cart ? (
    <>
      <div
        className={styles.timerWrapper}
        onClick={() => setOpen('deliveryReservation', !open)}
      >
        <IconTruckDelivery />
        <div>
          {isNotNilOrEmpty(cart?.tmsReservationSlotData) ? (
            <>
              <div className={styles.timerLabel}>Rezerwacja terminu dostawy</div>
              <div className={styles.buttonLabel}>
                <div className={styles.dateLabel}>
                  {cart.tmsReservationSlotData?.slot?.date || '---'}
                </div>
                {cart?.tmsReservationSlotData?.slotExtended?.from &&
                  cart?.tmsReservationSlotData?.slotExtended?.to && (
                    <div>
                      {formatDeliveryExtendedData(
                        cart.tmsReservationSlotData.slotExtended.from,
                        cart.tmsReservationSlotData.slotExtended.to
                      )}
                    </div>
                  )}
              </div>
            </>
          ) : isNotNilOrEmpty(firstAvailableTmsDeliverySlot) ? (
            <>
              <div className={styles.timerLabel}>Najbliższa możliwa dostawa</div>
              <div className={styles.buttonLabel}>
                {firstAvailableTmsDeliverySlot?.date}{' '}
                {firstAvailableTmsDeliverySlot?.startTime} -{' '}
                {firstAvailableTmsDeliverySlot?.endTime}
              </div>
            </>
          ) : (
            <>
              <div className={styles.timerLabel}>Dostawa</div>
              <div className={styles.buttonLabel}>Wybierz</div>
            </>
          )}
        </div>
        <div
          className={clsx(styles.iconWrapper, {
            [styles.iconWrapperOpen]: open
          })}
        >
          <IconChevronDown />
        </div>
      </div>
      <StyledDrawer
        id='delivery-reservation-modal'
        open={open}
        onClose={() => setOpen('deliveryReservation', false)}
        placement='top'
        $isRibbonActive={!!ribbon}
      >
        <div className={styles.drawerContent}>
          <DrawerTitle>Potwierdź czas dostawy</DrawerTitle>
          <CartDeliverySlotSelectionView isInDropdown setOpenDropdown={setOpen} />
        </div>
      </StyledDrawer>
    </>
  ) : null
}

export default DeliveryReservationModal

export const StyledDrawer = ({
  $isRibbonActive,
  className,
  ...props
}: DrawerProps & { $isRibbonActive: boolean }) => (
  <Drawer
    className={clsx(
      styles.styledDrawer,
      { [styles.styledDrawerWithRibbon]: $isRibbonActive },
      className
    )}
    {...props}
  />
)
